import React, { useState, useEffect } from 'react';
import axios from 'axios';

function APITwoBrandForm() {
  const [inputs, setInputs] = useState({
    input_date: '',
    input_name: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [apiEndpoint, setApiEndpoint] = useState('');

  useEffect(() => {
    const fetchApiEndpoint = async () => {
      try {
        const res = await axios.get('/wp-json/custom/v1/options');
        setApiEndpoint(res.data.fuselight_api_2a_testing);
      } catch (error) {
        console.error('Error fetching API endpoint:', error);
      }
    };

    fetchApiEndpoint();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    console.log('Sending data:', inputs);
    setResults([]);
    setErrorMessage('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoint,
          data: inputs
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received data:', res.data);
      setResults(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessage(`Error: ${message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            name="input_date"
            value={inputs.input_date}
            onChange={handleChange}
            placeholder="Date (YYYY-MM-DD)"
          />
          <input
            type="text"
            name="input_name"
            value={inputs.input_name}
            onChange={handleChange}
            placeholder="Brand Name"
          />
        </div>
        <div className="form-row">
          <button type="submit">Submit</button>
        </div>
      </form>
      {isLoading && <div className="loading-message">Loading...</div>}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <div className="results-section">
        {results.geo && (
          <div>
            <h3 className="h4">Geo Results</h3>
            <ul>
              {results.geo.map((geo, index) => (
                <li key={index}>
                  {geo.region}: {geo.geo_score}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default APITwoBrandForm;
